import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { InstanceTypesResponse } from "../types";

export type onboardingInitialStates = {
  isLoadingInstanceTypes: boolean;
  instaceTypes: InstanceTypesResponse | null;
  teamName: string;
  authorEmail: string;
  projectName: string;
  templateType: string;
};

const initialState: onboardingInitialStates = {
    isLoadingInstanceTypes: false,
    instaceTypes: null,
    teamName: "",
    authorEmail: "",
    projectName: "",
    templateType: "",
};

const sagaReducers = {
  callToLoadInstanceTypes: () => {},
};

export const userDataSlice = createSlice({
  name: "mlops",
  initialState,
  reducers: {
    ...sagaReducers,
    setIsLoadingInstanceTypes: (state, action: PayloadAction<boolean>) => {
      state.isLoadingInstanceTypes = action.payload;
    },
    setInstaceTypes: (state, action: PayloadAction<InstanceTypesResponse | null>) => {
        state.instaceTypes = action.payload;
    },
    setTeamName: (state, action: PayloadAction<string>) => {
      state.teamName = action.payload;
    },
    setAuthorEmail: (state, action: PayloadAction<string>) => {
      state.authorEmail = action.payload;
    },
    setProjectName: (state, action: PayloadAction<string>) => {
      state.projectName = action.payload;
    },
    settemplateType: (state, action: PayloadAction<string>) => {
      state.templateType = action.payload;
    },
  },
});

export const {
    setIsLoadingInstanceTypes,
    callToLoadInstanceTypes,
    setInstaceTypes,
    setTeamName,
    setAuthorEmail,
    setProjectName,
    settemplateType,
} = userDataSlice.actions;
export default userDataSlice.reducer;
